import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import "jquery-confirm/css/jquery-confirm.css";
import "jquery-confirm";
import { useHistory, useParams, withRouter } from "react-router-dom";
import ManualJuego from "../components/manualJuego";
import TraerCuponesPendientesDesktop from "../components/traerCuponesPendientesDesktop";
import TraerCuponesPendientesLotoides from "../components/traerCuponesPendientesLotoides";
import TraerCuponesPendientesPoceada from "../components/traerCuponesPendientesPoceada";

const Juego = (props) => {
  //----------------HOOKS DE ESTADO -----------------------
  const [urlIframeJuego, seturlIframeJuego] = useState(undefined);
  const { nombrejuego } = useParams();
  const [mandoMsj, setMandoMsj] = useState(false);
  const iframeRef = useRef();
  const [iframeContent, setIframeContent] = useState();

  //----------------- HISTORY -------------------------------
  const history = useHistory();

  //------------------ HOOKS DE EFECTO ----------------------
  useEffect(() => {
    if (props.estadoPlataforma.estado === "PLATAFORMA") {
      history.push("/home");
    }
  });

  useEffect(() => {
    switch (nombrejuego) {
      case "Quinielatradicional":
        seturlIframeJuego(
          process.env.REACT_APP_URL_BASE_FRONTEND +
            process.env.REACT_APP_URL_JUEGO_TOMBOLA
        );
        break;
      case "Quiniela Instantánea":
        seturlIframeJuego(
          process.env.REACT_APP_URL_BASE_FRONTEND +
            process.env.REACT_APP_URL_JUEGO_TOMBO_EXPRESS
        );
        break;
      case "quinielainstantanea":
        seturlIframeJuego(
          process.env.REACT_APP_URL_BASE_FRONTEND +
            process.env.REACT_APP_URL_JUEGO_TOMBO_EXPRESS
        );
        break;
      case "patagoniaminibingo":
        seturlIframeJuego(
          process.env.REACT_APP_URL_BASE_FRONTEND +
            process.env.REACT_APP_URL_JUEGO_PATA_MINIBINGO
        );
        break;
      case "patagoniatelebingo":
        seturlIframeJuego(
          process.env.REACT_APP_URL_BASE_FRONTEND +
            process.env.REACT_APP_URL_JUEGO_PATA_TELEBINGO
        );
        break;
      case "Tombola":
        seturlIframeJuego(
          process.env.REACT_APP_URL_BASE_FRONTEND +
            process.env.REACT_APP_URL_JUEGO_TOMBOLA
        );
        break;
      case "LaQuiniela":
        seturlIframeJuego(
          process.env.REACT_APP_URL_BASE_FRONTEND +
            process.env.REACT_APP_URL_JUEGO_TOMBOLA
        );
        break;
      case "Laquiniela":
        seturlIframeJuego(
          process.env.REACT_APP_URL_BASE_FRONTEND +
            process.env.REACT_APP_URL_JUEGO_TOMBOLA
        );
        break;
      case "QuiniExpress":
        seturlIframeJuego(
          process.env.REACT_APP_URL_BASE_FRONTEND +
            process.env.REACT_APP_URL_JUEGO_TOMBO_EXPRESS
        );
        break;
      case "TomboExpress":
        seturlIframeJuego(
          process.env.REACT_APP_URL_BASE_FRONTEND +
            process.env.REACT_APP_URL_JUEGO_TOMBO_EXPRESS
        );
        break;
      case "pozodelaquiniela":
        seturlIframeJuego(
          process.env.REACT_APP_URL_BASE_FRONTEND +
            process.env.REACT_APP_URL_JUEGO_POZO
        );
        break;
      case "loteriaunificada":
        seturlIframeJuego(
          process.env.REACT_APP_URL_BASE_FRONTEND +
            process.env.REACT_APP_URL_JUEGO_LOTERIA_UNIFICADA
        );
        break;
      case "raspadita_money":
        seturlIframeJuego(process.env.REACT_APP_URL_JUEGO_RASPADITA);
        window.setmanualJuego(
          <ManualJuego
            className="navbar-brand"
            manualesJuego="https://ijan-neuquen.com/reglamento.php?id=28"
            style={{ zIndex: "999" }}
          />
        );
        window.setnotificacionesJuego(
          <TraerCuponesPendientesDesktop
            className="mr-4"
            pendientes={0 /*cuponesPend.cuponesSinSortear*/}
            traerCupones={() => console.log()}
            refreshCup={() => console.log()}
            juego={nombrejuego}
            estadoPlataforma={props.estadoPlataforma}
          />
        );
        break;
      case "quini6":
        // console.log(props);

        seturlIframeJuego(
          process.env.REACT_APP_URL_BASE_FRONTEND +
            process.env.REACT_APP_URL_JUEGO_QUINI
        );

        window.setmanualJuego(
          <ManualJuego
            className="navbar-brand"
            manualesJuego="https://www.loteriadesalta.com/como-jugar/#tab-3157"
            style={{ zIndex: "999" }}
          />
        );

        window.setnotificacionesJuego(
          <TraerCuponesPendientesLotoides
            juego={nombrejuego}
            estadoPlataforma={props.estadoPlataforma}
          />
        );

        break;
      case "lotoplus":
        seturlIframeJuego(
          process.env.REACT_APP_URL_BASE_FRONTEND +
            process.env.REACT_APP_URL_JUEGO_LOTOPLUS
        );
        const manualLotoplusUrl = ["12", "42"].includes(
          process.env.REACT_APP_COD_ORGANIZACION
        )
          ? "https://issuu.com/arteymania/docs/manual_apostador__2018_-_corregido_/42?fr=sZGIzNjM2ODMyNzU"
          : "https://www.loteriadesalta.com/como-jugar/#tab-3156";
        window.setmanualJuego(
          <ManualJuego
            className="navbar-brand"
            manualesJuego={manualLotoplusUrl}
            style={{ zIndex: "999" }}
          />
        );

        window.setnotificacionesJuego(
          <TraerCuponesPendientesLotoides 
            juego={nombrejuego}
            estadoPlataforma={props.estadoPlataforma}
          />
        );

        break;
      case "poceada":
        seturlIframeJuego(
          process.env.REACT_APP_URL_BASE_FRONTEND +
            process.env.REACT_APP_URL_JUEGO_POCEADA
        );
        window.setmanualJuego(
          <ManualJuego
            className="navbar-brand"
            manualesJuego="https://www.loteriacorrentina.gob.ar/_files/ugd/ad6c8e_85ea0a77689b4d9c987102b40d8d4963.pdf"
            style={{ zIndex: "999" }}
          />
        );
        window.setnotificacionesJuego(
          <TraerCuponesPendientesPoceada
            juego={nombrejuego}
            estadoPlataforma={props.estadoPlataforma}
          />
        );
        
        break;

      default:
        break;
    }
  }, [props.estadoPlataforma.logueado]);

  useEffect(() => {
    window.scrollTo(0, 0);
    props.arrancarJuego(urlIframeJuego);

    if (
      urlIframeJuego !== undefined &&
      nombrejuego === "raspadita_money" &&
      !mandoMsj
    ) {
      setTimeout(() => {
        let juego = iframeRef.current.contentWindow;
        juego.postMessage(
          props.estadoPlataforma.userToken,
          process.env.REACT_APP_URL_JUEGO_RASPADITA
        );

        window.addEventListener("message", (e) => {
          //console.log(e);
          if (e.data === "ActualizoSaldoMoney") {
            setTimeout(() => {
              window.refreshSaldo();
            }, 1000);
          }
        });
        setMandoMsj(true);
      }, 1000);
    }
  }, [urlIframeJuego, nombrejuego]);

  useEffect(() => {
    const handleMessage = (event) => {
      if (
        [
          "http://localhost:3001",
          "http://localhost:3002",
          "https://testsalta.tecnoaccion.com.ar",
          "https://loteriadesaltaonline.bet.ar",
        ].includes(event.origin)
      ) {
        const { type, path } = event.data;

        if (type === "navigate-balance" && path) {
          window.location.pathname = path;
        }
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  /**
   * Se ejecuta la funcion @terminoCargaJuego proveniente del componente padre
   */
  const cargoElIFrame = () => {
    props.terminoCargaJuego();
  };

  return props.estadoPlataforma.estado === "PLATAFORMA" ? (
    <></>
  ) : (
    <>
      {urlIframeJuego !== undefined && (
        <iframe
          ref={iframeRef}
          onLoad={cargoElIFrame}
          src={urlIframeJuego}
          style={{ visibility: "visible" }}
          title="juego"
          id="zonaJuego"
          className={`zonaJuego_${nombrejuego}`}
          sandbox="allow-same-origin allow-scripts allow-downloads"
          frameBorder="0"
        />
      )}

      {/*  <iframe
        ref={iframeRef}
        src={"http://localhost:3001"}
        style={{ visibility: "visible" }}
        title="prueba"
        id="zonaJuego"
      />*/}
    </>
  );
};

export default withRouter(Juego);
